export enum SEARCH_PARAMS {
    campaign = 'campaign',
    entry = 'entry',
    reviewId = 'reviewId',
    step = 'step',
    task = 'task',
    viewType = 'viewType',
    verifyTab = 'verifyTab',
    drawer = 'drawer',
}
export type SearchParamObject = Partial<Record<SEARCH_PARAMS, string>>
export interface HistorySearchObject {
    key: SEARCH_PARAMS
    value: string
}
interface SetSearchParams {
    add?: HistorySearchObject[]
    remove?: SEARCH_PARAMS[]
}

/**
 * @param add list of key-value pair to add for search params
 * @param remove list of key to remove from search params
 */
export const getSearchParams = ({ add, remove }: SetSearchParams) => {
    const searchObj = new URLSearchParams(window.location.search)
    add?.forEach(({ key, value }) => searchObj.set(key, value))
    remove?.forEach(key => searchObj.delete(key))
    return '?' + searchObj.toString()
}
